import { all, put, takeEvery } from "@redux-saga/core/effects";
import { updateWorkforce } from "../../Services/database";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";
import {
  reauthenticate,
  updateAccountPassword
} from "../../Services/authentication";

export const actionTypes = {
  SET_ACCOUNT_PROFILES: "SET_ACCOUNT_PROFILES",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  UPDATE_PASSWORD: "UPDATE_PASSWORD"
};

function* setProfilesWorker(action) {
  try {
    yield put({
      type: "SET_PROFILES",
      payload: action.payload.profiles
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* updateProfileWorker(action) {
  try {
    const profile = store.getState().profile;
    yield updateWorkforce(profile.data.employeeId, action.payload.profileData);
    setSuccessStatus("Profile updated");

    // const fileBlob = yield uploadFile(action.payload.picture.data);
    // if (action.payload.picture && action.payload.picture.type === "update") {
    //   // editPicture(
    //   //   {
    //   //     employee: {
    //   //       ...(props.employeeData.type === "admin"
    //   //         ? { email: props.employeeData.email }
    //   //         : { phoneNumber: props.employeeData.phoneNumber }),
    //   //       name: props.employeeData.name,
    //   //       id: props.employeeData.employeeId,
    //   //     },
    //   //   },
    //   //   fileBlob,
    //   //   props.referencePictureData?.documentId
    //   // );
    // } else {
    //   createNewProfilePicture(profile.data.employeeId, fileBlob)
    // }
  } catch (error) {
    console.error(error);
    setErrorStatus(error);
  }
}

function* updatePasswordWorker(action) {
  try {
    yield reauthenticate(action.payload.email, action.payload.currentPassword);
    yield updateAccountPassword(action.payload.newPassword);
    yield setSuccessStatus("Password updated successfully.");
  } catch (error) {
    console.error("Error updating password:", error);
    yield setErrorStatus(error.message);
  }
}

export default function* profileWatcher() {
  yield all([takeEvery("SET_ACCOUNT_PROFILES", setProfilesWorker)]);
  yield all([takeEvery("UPDATE_PROFILE", updateProfileWorker)]);
  yield all([takeEvery("UPDATE_PASSWORD", updatePasswordWorker)]);
}

// function* setProfileLoading(bool) {
//   yield put({
//     type: "SET_PROFILE_LOADING",
//     payload: {
//       loading: bool,
//     },
//   });
// }
